import { useTranslation } from "react-i18next";

import { USAIDObject } from "../../../../models/USAIDObject";
import { useActions } from "../../../../hooks/useActions";
import { useTypedSelector } from "../../../../hooks/useTypedSelector";
import useMobileScreen from "../../../../hooks/useMobileScreen";
import { breakpoints } from "../../../../constants";
import JpBlue from "../../../../assets/svg/JpBlue.svg";
import NpGreen from "../../../../assets/svg/NpGreen.svg";
import {
  ListViewHeaderCell,
  ListViewHeaderIconSpacer,
  ListViewHeaderRow,
  ListViewStickyHeader,
} from "../../../../share/searchResults";
import SearchResultsResponsive from "../../../../share/searchResults/SearchResultsResponsive";
import GeneralSearchResultItem from "../../../../share/GeneralSearchResultItem/GeneralSearchResultItem";

const USAIDMapSearchResults = () => {
  const {
    setCleanAllUSAIDFilters,
    getDefaultUSAIDResult,
    refreshFeedForUSAIDSearchResults,
  } = useActions();
  const { usaid_dataset, count } = useTypedSelector(
    (state) => state.mapUSAIDInfo
  );
  const { isListViewActive } = useTypedSelector((state) => state.mapInterface);

  const isMobile = useMobileScreen(breakpoints.medium);
  const shouldRenderHeader =
    isListViewActive &&
    !isMobile &&
    Boolean(usaid_dataset && usaid_dataset.length > 0);

  const { t } = useTranslation("translation", {
    keyPrefix: "mainPage.mapFilters.listView.headers.usaid",
  });

  const handleClean = () => {
    setCleanAllUSAIDFilters();
    getDefaultUSAIDResult();
  };

  return (
    <SearchResultsResponsive
      onClearAllFilters={handleClean}
      count={count}
      handleLoadFeed={refreshFeedForUSAIDSearchResults}
    >
      {shouldRenderHeader && (
        <ListViewStickyHeader>
          <ListViewHeaderRow>
            <ListViewHeaderIconSpacer aria-hidden="true" />
            <ListViewHeaderCell flex="2 1 320px">
              {t("participant")}
            </ListViewHeaderCell>
            <ListViewHeaderCell flex="1 1 220px">
              {t("category")}
            </ListViewHeaderCell>
            <ListViewHeaderCell flex="1 1 220px">
              {t("income2022")}
            </ListViewHeaderCell>
          </ListViewHeaderRow>
        </ListViewStickyHeader>
      )}
      {usaid_dataset?.map((mapObject: USAIDObject) => {
        const imgSrc =
          mapObject.entity_type === "Юридична особа" ? JpBlue : NpGreen;
        const category = mapObject.category || "—";
        const incomeText =
          mapObject && mapObject.income_2022_usd
            ? `${(mapObject.income_2022_usd * 1000).toFixed(2)} USD`
            : "Не визначено";
        const paragraphs = [mapObject.edrpou, category, incomeText];
        return (
          <GeneralSearchResultItem
            key={mapObject.id}
            title={mapObject.name}
            lat={mapObject.lat}
            lon={mapObject.lon}
            hashId={mapObject.id}
            imgSrc={imgSrc}
            paragraphs={paragraphs}
          />
        );
      })}
    </SearchResultsResponsive>
  );
};

export default USAIDMapSearchResults;
